import {Component, inject, Input, OnChanges} from '@angular/core';
import {SectionsContainer} from '../../core/definitions/sections-container';
import {MetaField} from '../../core/definitions/meta-field';
import {CmsApiService} from '../../core/cms-api.service';
import {FieldInputType} from '../../core/definitions/field-input-type.enum';
import {BaseModel} from '../../core/definitions/base-model';
import {MetaOperationFieldService} from "../../core/meta-operation-field.service";

@Component({
  selector: 'app-edit-field-meta-operation-field',
  templateUrl: './edit-field-meta-operation-field.component.html',
  styleUrls: ['./edit-field-meta-operation-field.component.scss'],
  standalone: false
})
export class EditFieldMetaOperationFieldComponent implements OnChanges {
  // Injections
  private readonly cms: CmsApiService = inject(CmsApiService);
  private readonly metaOperationFieldService: MetaOperationFieldService = inject(MetaOperationFieldService);

  @Input() displayRequiredIndication: boolean;
  @Input() sectionsContainer: SectionsContainer;
  @Input() field: MetaField;
  @Input() setAddChoice: string;
  @Input() parentIndex: number;
  @Input() index: number;
  @Input() setValueObject: BaseModel;
  @Input() selectedFieldId: string;
  @Input() operationField: MetaField;

  FieldInputType = FieldInputType;
  myParentIndex: number;

  ngOnChanges(): void {
    if (this.setAddChoice) {
      for (const subField of this.operationField.sub_fields) {
        subField.$$hide = ['add_before_existing_text', 'add_after_existing_text'].includes(
          this.setAddChoice) && this.operationField.inline.prop !== subField.name;
      }
    }
    this.setMetaOperationField().then();
  }

  private async setMetaOperationField() {
    if (this.sectionsContainer.rootObject.object_type === 'MultipleFieldValueOperationModel') {
      this.myParentIndex = this.index;
    } else {
      this.index = 0;
    }
    const clearExistingValue = await this.setMetaOperationFieldInternal();
    await this.metaOperationFieldService.setTheValueObject(
      this.sectionsContainer, this.field, this.operationField, this.setValueObject, this.myParentIndex,
      clearExistingValue);
  }

  private async setMetaOperationFieldInternal(): Promise<boolean> {
    if (!this.selectedFieldId) {
      console.error('Selected field id not set!');
      return;
    }
    let clearExistingValue = false;
    if (this.operationField) {
      if (!this.selectedFieldId.includes(this.operationField.field_uuid)) {
        this.operationField = await this.cms.getMetaFieldById(this.selectedFieldId);
        console.log('setting operation field from meta op component');
        clearExistingValue = true;
      }
    } else {
      console.log('operation field not set');
    }
    return clearExistingValue;
  }

}
